"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _zzt = require("../utils/zzt");
var _common = require("../utils/common");
var _log = _interopRequireDefault(require("../utils/log"));
var _lego = require("../lego");
var _legoDebugTool = _interopRequireDefault(require("../plugins/lego-debug-tool"));
var _setWebViewPageId = require("../utils/setWebViewPageId");
var _initLoadSdk = require("../utils/initLoadSdk");
var _package = _interopRequireDefault(require("../../package.json"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// 提前加载skd
(0, _initLoadSdk.initLoadSdk)();
var legoInitLite = function legoInitLite() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    log: false,
    autoOcd: true
  };
  // 只支持浏览器环境
  if (typeof window === 'undefined' && window === null) {
    return;
  }
  try {
    // 处理调试工具
    if (!!(0, _common.getQuery)('OPEN_DEVTOOL_LEGO')) {
      params.debugger = true;
      (0, _legoDebugTool.default)(params);
    }
    if (!!(0, _common.getQuery)('OPEN_DEVTOOL_LEGO_CACHE')) {
      params.debuggerCache = true;
    }
    // 初始化全局参数
    window.__ZZ_LEGO_CONFIG = params;
    if (params.log) {
      console.log("[lego\u65E5\u5FD7] lego\u65E5\u5FD7\u5F00\u542F\uFF0C\u8BF7\u5728\u63A7\u5236\u53F0\u65E5\u5FD7\u7B5B\u9009\uFF0Clego\u65E5\u5FD7\u5173\u952E\u5B57");
    }
    try {
      _log.default.info("lego\u7248\u672C".concat(_package.default.version));
      _log.default.info("lego\u521D\u59CB\u5316\uFF0C\u521D\u59CB\u5316\u53C2\u6570\u4E3A", params);
    } catch (error) {}

    // 设置t值
    (0, _zzt.zzt)(params.t);
    // 设置tk值
    (0, _zzt.zztk)();
    // 设置 referer 值
    (0, _zzt.initReferer)();
    // 过滤中 pageuqery 无效值, 防止 url 过长
    if (params.pagequery) {
      params.pagequery = (0, _common.filterQuery)(params.pagequery);
    }
    // 设置本次初始化默认cookie
    var body = _objectSpread({}, params);
    if (body.forbidLegoInPrerender || body.forbidLegoInHidden) {
      (0, _lego.setForbidLegoFlag)({
        forbidLegoInPrerender: body.forbidLegoInPrerender,
        forbidLegoInHidden: body.forbidLegoInHidden
      });
    }
    if (params.routeList) {
      (0, _common.setPageIdObj)(params.routeList);
      body.pageIdInfo = (0, _common.getPageIdInfo)();
      // 端内 通知客户端当前 pageid
      (params === null || params === void 0 ? void 0 : params.autoOcd) && (0, _setWebViewPageId.setWebViewPageId)();
    }
    delete body.routeList;
    window['zz_lego_backup'] = Object.assign({}, window['zz_lego_backup'], body) || {};
    _log.default.info("lego\u521D\u59CB\u5316\uFF0C\u8BBE\u7F6Ezz_lego_backup\u503C\u5B8C\u6210\uFF0Czz_lego_backup\u503C\u4E3A", body);
    if (legoInitLite.pluginList && legoInitLite.pluginList.length > 0) {
      legoInitLite.pluginList.forEach(function (init) {
        init(params);
      });
    }
  } catch (err) {
    _log.default.error("lego\u521D\u59CB\u5316\u5931\u8D25\uFF0C\u9519\u8BEF\u4E3A".concat(err));
  }
};
legoInitLite.pluginList = [];
legoInitLite.use = function (plugin) {
  if (!plugin) return;
  if (legoInitLite.pluginList.includes(plugin)) return;
  legoInitLite.pluginList.push(plugin);
  return legoInitLite;
};
var _default = exports.default = legoInitLite;